const isFunction = fn => typeof fn === 'function';

export default isFunction;
